// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f4e22a21","968":"e53e3249","977":"6d397d93"}[chunkId] + ".chunk.js";
};